import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Box } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";
import ConfirmDelete from "../../ManageCategories/ConfirmDelete";

import { showToast } from "../../../store/slices/common";
import TablePagination from "../../../components/Table/TablePagination";
import Button from "../../../components/Button";
import { deleteResource, deleteSponsor } from "../../../http/auth";
import AddResourceModal from "./AddResourceModal";

const ResourcesTable = ({
  setLoading,
  columns,
  rows,
  page,
  setPage,
  nextId,
  onNextClick,
  onPrevClick,
  rowsPerPage,
  totalCount,
  getResourceList,
}) => {
  const [openCreate, setOpenCreate] = useState(false);
  const [openView, setOpenView] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [deleteId, setDeleteId] = useState("");
  const [editableResource, setEditableResource] = useState({});
  const dispatch = useDispatch();

  const createHandler = () => {
    setEditableResource({});
    setOpenCreate(true);
  };

  const editHandler = (item) => {
    setEditableResource(item);
    setOpenEdit(true);
  };

  const deleteHandler = (id) => {
    setDeleteId(id);
    setOpenDelete(true);
  };

  const viewHandler = (row) => {
    setEditableResource(row);
    setOpenView(true);
  };

  const confirmDeleteHandler = async () => {
    try {
      setLoading(true);
      const res = await deleteResource(deleteId);
      dispatch(showToast({ color: "success", msg: res.data.message?.en }));
      await getResourceList();
      setLoading(false);
    } catch (err) {
      // dispatch(showToast({ color: "error", msg: err?.response?.data?.message || "Something went wrong" }));
      setLoading(false);
    }
  };

  const renderContent = (value, rowIndex, row) => {
    if (value === "-") {
      return (
        <>
          {/* <VisibilityOutlinedIcon sx={{ color: "blue", cursor: "pointer" }} onClick={() => viewHandler(row)} /> */}
          <ModeEditOutlineOutlinedIcon
            sx={{ color: "blue", cursor: "pointer", marginLeft: "10px" }}
            onClick={() => editHandler(row, true)}
          />
          <DeleteOutlineIcon
            sx={{ color: "red", cursor: "pointer", marginLeft: "10px" }}
            onClick={() => deleteHandler(row?.id)}
          />
        </>
      );
    } else if (typeof value === "number") {
      return (page - 1) * 10 + rowIndex + 1;
    } else return row.description?.en;
  };

  return (
    <div style={{ height: "calc(100% - 61px)" }}>
      {openCreate && (
        <AddResourceModal
          open={openCreate}
          setOpen={setOpenCreate}
          isEdit={false}
          getResourceList={getResourceList}
          setPage={setPage}
        />
      )}
      {openEdit && (
        <AddResourceModal
          open={openEdit}
          setOpen={setOpenEdit}
          isEdit={true}
          getResourceList={getResourceList}
          resource={editableResource}
        />
      )}
      {openView && (
        <AddResourceModal
          open={openView}
          setOpen={setOpenView}
          isView={true}
          getResourceList={getResourceList}
          resource={editableResource}
        />
      )}
      {openDelete && (
        <ConfirmDelete
          open={openDelete}
          setOpen={setOpenDelete}
          confirmDelete={confirmDeleteHandler}
        />
      )}
      <TableContainer
        sx={{
          width: "calc(100% - 2px)",
          borderRadius: "10px",
          marginTop: "12px",
          maxHeight: "calc(100% - 68px)",
          border: "1px solid rgba(224, 224, 224, 1)",
          overflowY: "auto",
        }}
      >
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              <TableCell colSpan={columns.length} style={{ padding: 0 }}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    gap: "2rem",
                    padding: "1rem",
                    background: "#fff",
                    position: "sticky",
                    top: 0,
                    zIndex: 1,
                  }}
                >
                  <Button
                    onClick={() => createHandler()}
                    variant="contained"
                    label="Add Resource"
                    style={{ width: "150px" }}
                  />
                </Box>
              </TableCell>
            </TableRow>
            <TableRow sx={{ position: "sticky", top: "80px", zIndex: "1" }}>
              {columns.map((column, index) => {
                const textAlignStyle =
                  column.label === "Action" ? "center" : "start";
                return (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{
                      minWidth: column.minWidth,
                      textAlign: textAlignStyle,
                    }}
                    sx={{
                      color: "#323C47",
                      fontSize: "16px",
                      fontWeight: "700",
                    }}
                  >
                    {column.label}
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            {console.log(rows)}
            {rows.map((row, rowIndex) => {
              return (
                <TableRow hover role="checkbox" tabIndex={-1} key={row?._id}>
                  {columns.map((column, ind) => {
                    const value = row[column.id];
                    const pad = value === "-" ? "10px !important" : "auto";
                    const alignment = value === "-" ? "center" : "start";

                    return (
                      <TableCell
                        key={column.id}
                        align={column.align}
                        sx={{
                          color: "#323C47",
                          fontSize: "16px",
                          height: "24px",
                          padding: pad,
                          textAlign: alignment,
                        }}
                      >
                        {renderContent(value, rowIndex, row)}
                      </TableCell>
                    );
                  })}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      {totalCount > 10 && (
        <TablePagination
          page={page}
          nextId={nextId}
          onNextClick={onNextClick}
          onPrevClick={onPrevClick}
          totalCount={totalCount}
        />
      )}
    </div>
  );
};

export default ResourcesTable;
